// 模組07 訊息功能 — 系統事件通知設定 mock 種子(9月交付 ticket 09)。
//
// 對稿:WF_v3「各類訊息設定」第二分頁(系統事件)。確認單 Q34:系統事件固定發送、
// 不可停用,僅可調整接收管道;帳號與密碼類連管道都不可調(稿上該列為 --)。
// 全部列收在**一筆設定文件**(rows 陣列):送出時整批一張審核單,
// 與批次匯入「整批一單」同慣例,核准後由審核引擎把 payload.rows 寫回。
export const notifyEventSettings = [
  {
    id: 1,
    rows: [
      {
        key: "account",
        group: "帳號與密碼",
        timing: "忘記密碼／重設完成／帳號建立／登入鎖定",
        receivers: "該使用者",
        adjustable: false,
        inApp: true,
        email: true,
        enabled: true,
      },
      {
        key: "dispatch",
        group: "派工狀態異動",
        timing: "報修中／派工中／已修復",
        receivers: "資產管理者・原報修人",
        adjustable: true,
        inApp: true,
        email: false,
        enabled: true,
      },
      {
        key: "owner-change",
        group: "管理者／負責人變更",
        timing: "工作轉派核准生效／資產管理者變更",
        receivers: "新舊負責人",
        adjustable: true,
        inApp: true,
        email: false,
        enabled: true,
      },
      {
        key: "send-failure",
        group: "通知發送失敗",
        timing: "Email／簡訊閘道重試 3 次仍失敗",
        receivers: "系統管理者",
        adjustable: true,
        inApp: true,
        email: false,
        enabled: true,
      },
    ],
    updatedBy: "王志明（總經理室）",
    updatedAt: "2026-08-01T09:00:00+08:00",
  },
];
